export default __webpack_public_path__ + "static/media/warning--ford--g1.a4e7c139.png";